var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('router-link',{attrs:{"to":_vm.url + '/edit/' + _vm.id}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }